import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const fetchTeaser = async () => {
  const { data } = await api.get("/teaser");
  return data; // may be null
};

export const fetchShippingInfo = async () => {
  const { data } = await api.get("/shipping-info");
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await api.post("/orders", payload);
  return data;
};

export const validateDiscount = async (code, subtotal) => {
  const { data } = await api.post("/discounts/validate", { code, subtotal });
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

export const fetchConfig = async () => {
  const { data } = await api.get("/config");
  return data;
};

export const submitConsumerRequest = async (payload) => {
  const { data } = await api.post("/requests/consumer", payload);
  return data;
};

export const submitB2BRequest = async (payload) => {
  const { data } = await api.post("/requests/b2b", payload);
  return data;
};

export const submitMerchInterest = async (payload) => {
  const { data } = await api.post("/requests/merch-interest", payload);
  return data;
};

export const convertRequestToInvoice = async (reqId, payload, headers) => {
  const { data } = await api.post(`/admin/requests/b2b/${reqId}/create-invoice`, payload, { headers });
  return data;
};
